module.exports = __webpack_public_path__ + "img/tryher-timeline.c1d2819b.png";